import React from 'react'

const About = (props) => {
    return <h1> STOCKS STOCKS STOCKS, iStock delivers what you need. Stock prices and their symbol. Don't want to go to your stock page and be tempted to buy? We are here for you.</h1>
}
export default About